import _ from 'lodash'
import React, { Component } from 'react'
import RSVP from 'react-rsvp-module'
import Page from './Page'
import translations from './locales'

class App extends Component {
  constructor(props) {
    super(props);
    let locale = window.location.hash.split('/')[1]
    const available_locales = process.env.REACT_APP_AVAILABLE_LOCALES.split('|') || []
    if (_.isEmpty(locale) || available_locales.indexOf(locale) === -1) {
      locale = process.env.REACT_APP_DEFAULT_LOCALE
    }
    this.state = {
      locale,
    };
  }

  componentDidMount() {
    this.updateLanguage(this.state.locale);
  }

  updateLanguage = (locale, cb = undefined) => {
    // This assumes we're using window.location.hash for routing!!!
    const { hash } = window.location;
    const re = new RegExp(`/(${process.env.REACT_APP_AVAILABLE_LOCALES})/`);
    window.location.hash = hash === '#/' ? `#/${locale}/` : hash.replace(re, `/${locale}/`);
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('lang', locale);
    this.setState({
      locale,
    }, () => _.isFunction(cb) && cb());
  }

  openLanguageSwitcher = () => {
    this.rsvp.openModal({
      small: true,
      title: 'Select Language',
      buttons: [{
        text: 'English',
        onClick: () => this.updateLanguage('en', () => this.rsvp.closeModal()),
        secondary: true,
      }, {
        text: '繁体中文',
        onClick: () => this.updateLanguage('zh-HK', () => this.rsvp.closeModal()),
        secondary: true,
      }, {
        text: '简体中文',
        onClick: () => this.updateLanguage('zh-CN', () => this.rsvp.closeModal()),
        secondary: true,
      }],
    });
  }

  rsvp = null

  render() {
    return (
      <Page openLanguageSwitcher={this.openLanguageSwitcher}>
        <RSVP 
          ref={ref => this.rsvp = ref}
          locale={this.state.locale}
          onLocaleChange={this.updateLanguage}
          translations={translations}
        />
      </Page>
    );
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js